import React, { ReactElement } from 'react';
import Tippy from '@tippyjs/react';

interface HumanogramaLinkProps {
  id?: string;
  name?: string;
  data?: any;
  children: ReactElement | undefined;
}

const Humanograma: React.FC<HumanogramaLinkProps> = ({ data, children }) => {
  return (
    <a
      href={`https://humanograma.intranet.bb.com.br/${data?._id}`}
      target="_blank"
      rel="noreferrer"
      className="hover:text-white focus:text-white w-fit"
    >
      <Tippy
        allowHTML={true}
        content={
          <>
            <p className="m-0">
              Nome: <strong>{data?.nome}</strong>
            </p>
            <p className="m-0">
              Função: <strong>{data?.funcao}</strong>
            </p>
            <p className="m-0">
              Prefixo:{' '}
              <strong>
                {data?.prefixo} - {data?.nome_dependencia}
              </strong>
            </p>
            <p className="m-0 mt-2 text-electric-blue">Clique para o Humanograma</p>
          </>
        }
      >
        {children}
      </Tippy>
    </a>
  );
};

export default Humanograma;
